import { HttpStatusCode } from "axios";
import INavigationArea from "../models/navigation/INavigationArea";
import networkService from "./NetworkService";

class NavigationService {
    
    /**
     * @description Gets all navigation areas, optionally filtered by locale
     * @param {string} locale The locale to filter by (optional)
     */
    async getNavigation(locale?: string): Promise<INavigationArea[]> {
        const path = locale ? `/navigation/${locale}` : "/navigation";
        const result = await networkService.get<INavigationArea[]>(path);

        if (!result.isSuccessful) {
            throw result.data;
        }

        return result.status !== HttpStatusCode.NoContent
            ? result.data as INavigationArea[]
            : [];
    }

    /**
     * @description Updates navigation bar data
     * @param {INavigationSection[]} nav The navigation data to be saved
     */
    async saveNavigation(nav: INavigationArea[]): Promise<boolean> {
        const result = await networkService.patch<INavigationArea[], void>("/navigation", nav);
        return result.isSuccessful;
    }
}

const navigationService = new NavigationService();
export default navigationService;